<template>
  <div class="audience-form">
    <h2 v-if="presentation.audienceAdmission.heading" class="mt-0 text-center">
      {{ presentation.audienceAdmission.heading }}
    </h2>
    <form @submit.prevent="joinPresentation()">
      <div v-if="hasAudienceAdmissionFields">
        <div v-for="(item, index) in presentation.audienceAdmission.fields" :key="index">
          <div class="input-label">
            <span>{{ item.label }}</span>
            <span v-show="item.required" class="pl-1 text-danger">*</span>
          </div>
          <div class="item-input" :class="{error: item.error}">
            <input
              :type="getInputType(item.type)"
              :maxlength="item.textLimit"
              v-model="item.data"
              class="item-input-text"
              @input="onChangeInput(item)"
              :disabled="item.disabled"
            >
            <div class="item-input-limit" v-if="!item.disabled">
              {{ item.textLimit - item.data.length }}
            </div>
          </div>
          <div class="text-left error-field text-danger" v-if="item.error">
            {{ $t('mandatoryFieldError') }}
          </div>
        </div>
      </div>

      <div>
        <ui-button
          block
          size="lg"
          type="submit"
          :disabled="submiting"
        >
          <span>Join now</span>
          <i class="fas fa-check" v-if="!submiting" />
          <ui-spinner v-if="submiting" />
        </ui-button>
      </div>
      <div class="text-center text-danger padding" v-if="textError">
        {{ textError }}
      </div>
    </form>
  </div>
</template>

<script>
import storage from '@/services/storage'
import Util from '@/util'
import audienceApi from '@/api/audience'

// UI
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'
import { mapState } from 'vuex'

export default {
  components: {
    UiButton,
    UiSpinner,
  },
  data() {
    return {
      submiting: false,
      loading: true,
      textError: '',
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
    hasAudienceAdmissionFields() {
      return this.presentation.audienceAdmission.fields
        && this.presentation.audienceAdmission.fields.length
    },
  },
  created() {
    this.$store.state.presentation.audienceAdmission.fields =
      Util.formatFields(this.presentation.audienceAdmission.fields)
    document.body.classList.add('disable-loading-slide')
  },
  destroyed() {
    document.body.classList.remove('disable-loading-slide')
  },
  methods: {
    getInputType(itemType) {
      if (itemType === 'email') {
        return 'email'
      }
      return 'text'
    },
    onChangeInput(item) {
      item.error = false
      this.$store.state.presentation.audienceAdmission.fields.push()
    },
    _isValidFields() {
      this.presentation.audienceAdmission.fields.forEach((field) => {
        field.error = false
        const hasText = field.data && field.data.trim().length !== 0
        if (field.required && !hasText) {
          field.error = true
        }
      })
      return !this.presentation.audienceAdmission.fields.some((field) => field.error)
    },

    _getAdmissionPayloadToJoinPresentation(payload) {
      this.presentation.audienceAdmission.fields.forEach((field) => {
        const hasText = field.data && field.data.trim().length !== 0
        if (field.type === 'name' && hasText) {
          payload.name = field.data
        } else if (field.type === 'email' && hasText) {
          payload.email = field.data
        } else if (field.type === 'team' && hasText) {
          payload.organisation = field.data
        }
      })
    },

    async joinPresentation() {
      if (this.submiting) return
      this.textError = ''
      const { presentation } = this.$store.state
      this.submiting = true
      const payload = {
        audienceId: this.audienceId,
        presentationId: this.presentation.id,
      }

      if (!this._isValidFields()) {
        this.submiting = false
        return
      }
      this._getAdmissionPayloadToJoinPresentation(payload)

      try {
        storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
        await audienceApi.createAudience(payload)
        this.submiting = false
        if (payload.email) {
          this.$store.state.audienceEmail = payload.email
          storage.setValueByPresentation(
            presentation.id,
            'audienceEmail',
            payload.email,
          )
        }

        if (payload.name) {
          this.$store.state.audienceName = payload.name
          storage.setValueByPresentation(
            presentation.id,
            'audienceName',
            payload.name,
          )
        }

        if (payload.organisation) {
          this.$store.state.audienceTeam = payload.organisation
          storage.setValueByPresentation(
            presentation.id,
            'audienceTeam',
            payload.organisation,
          )
        }

        this.$store.state.presentation.audienceAdmission.fields =
          Util.formatFields(this.presentation.audienceAdmission.fields)
        this.$store.state.presentation.disableFormJoinPresentation = true

        Util.gaTrackEvent(
          'Audience',
          'Audience > Audience Admission > Joined',
        )
      } catch (error) {
        this.textError = this.$t('disconnectError')
        this.submiting = false
        Util.gaTrackEvent(
          'Audience',
          'Audience > Audience Admission > Failed',
          JSON.stringify(error),
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.disable-emoji {
  cursor: not-allowed;
}
.backdrop {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  position: fixed;
  background-color: #0000005c;
  left: 0;
  z-index: 10;
}

.box-search-team {
  .item-input-text {
    height: 44px;
  }
  .item-input-limit {
    top: 16px;
  }

  .team-name {
    text-align: left;
    word-break: break-word;
  }

  .content-box-search-team {
    padding: 10px;
    background-color: #fff;
    max-width: 680px;
    margin: 0 auto;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    height: 100%;
    .list-team {
      overflow-y: scroll;
      height: calc(100% - 44px - 16px);
      margin-top: 16px;
    }
  }
}

.team-item {
  font-weight: bold;
  min-height: 48px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;

  .index {
    font-weight: normal;
    min-width: 45px;
    padding: 0 8px 0 6px;
    text-align: right;
  }

  .team-color {
    width: 18px;
    height: 18px;
    background-color: black;
    border-radius: 3px;
    margin-right: 8px;
  }

  .form-control {
    height: 36px;
    border-radius: 5px;
    margin-right: 8px;

    &.error {
      border-color: $danger-color;
    }
  }

  button {
    width: 100px;
  }
}

.box-search-team {
  position: fixed;
  bottom: 0;
  width: 100%;
  color: #333;
  height: 500px;
  max-height: 100%;
  padding-top: 12px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  z-index: 999;
  left: 0;
}
.fake-input {
  width: 100%;
  height: 52px;
  border-radius: 8px;
  box-shadow: none;
  border: 2px solid #ddd;
  font-size: 18px;
  padding: 0px 40px 0 16px;
  -webkit-appearance: none;
  outline: none;
  line-height: normal;
  box-sizing: border-box;
  line-height: 49px;
  background-color: #fff;
  color: #afafaf;
  position: relative;
  cursor: pointer;
  text-align: left;

  &.danger {
    border-color: $danger-color;
  }

  &.active {
    color: #333;
  }

  .loading-spinner, .fas {
    position: absolute;
    right: 10px;
    top: 14px;
    color: #333;
  }
}
.audience-form {
  padding: 16px;

  .item-input {
    position: relative;
    margin-bottom: 16px;
    .invalid-team-note {
      padding-top: 7px;
    }
    .item-input-icon {
      cursor: pointer;
    }
    .filter-team-list-wrapper {
      .item-input-text {
        cursor: pointer;
        &.team-list-show {
          cursor: text;
        }
      }
    }
    .team-list {
      position: absolute;
      overflow: auto;
      border: 1px solid #ddd;
      z-index: 1;
      background-color: #ffffff;
      width: 100%;
      margin-top: 1px;
      padding-top: 10px;
      cursor: pointer;
      .team-listing {
        display: block;
        padding: 5px 16px;
        &:hover {
          background-color: #4f9af2;
          color: #ffffff;
        }
      }
    }
  }
  .pick-emoji {
    position: relative;
    cursor: pointer;
    width: fit-content;
    -webkit-tap-highlight-color: transparent;

    .emoji-mart {
      position: absolute;
      top: 90px;
      left: 0;
      z-index: 110;
    }
  }
  .emoji-picked {
    font-size: 80px;
    margin: 16px;
  }
  .text-action {
    color: $primary-color;

    &.white {
      color: #fff;
      text-decoration: underline;
    }
  }
  .button-submit {
    .loading-spinner {
      margin-bottom: 0px;
    }
  }
}
.input-label {
  text-align: left;
}

.error-field {
  margin-bottom: 8px;
}

.text-danger {
  text-align: left;
  margin-bottom: 16px;
  font-size: 13px;
}
</style>
